var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tr", [
    _c("td", { staticClass: "text-right" }, [
      _vm._v(_vm._s(_vm.formatNumber(_vm.vatGroup.TotalExcl))),
    ]),
    _c("td", { staticClass: "text-right" }, [
      _vm._v(_vm._s(_vm.vatGroup.VATPercentage) + "%"),
    ]),
    _c("td", { staticClass: "text-right" }, [
      _vm._v(_vm._s(_vm.formatNumber(_vm.vatGroup.TotalVAT))),
    ]),
    _c("td", { staticClass: "text-right" }, [
      _vm._v(_vm._s(_vm.formatNumber(_vm.vatGroup.TotalIncl))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }